module.exports = __webpack_public_path__ + "media/images/pro_subscription/carousel5-fr@3x-8b45682bf4658582ee18aa5d6ded9704.png";